export default "<p>millionare-app works!</p>\n"